import { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import * as signalR from "@microsoft/signalr";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import SoundEffect from "../../../components/basics/SoundEffect";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import Paginations from "../../../components/paginaton/Paginations";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const SnappOrders = () => {
  const { branchId, deskId } = useParams();
  const socketURL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const [localService, setLocalService] = useState({
    baseUrl: "",
  });
  const navigate = useNavigate();
  const staticsInfo = methods.getOrderingStatics();
  const [statuses, setStatuses] = useState([]);
  const [units, setUnits] = useState([]);
  const [cashDesks, setCashDesks] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [funds, setFunds] = useState([]);
  const [inActiveModal, setInActiveModal] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [printModel, setPrintModel] = useState({
    kitchenPrintModel: null,
    orderPrintModel: null,
    printers: [],
  });
  const [loading, setLoading] = useState(true);

  const [localPrinters, setlocalPrinters] = useState([]);

  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    unitId: 0,
    size: 20,
    part: 1,
    status: 0,
    fullName: "",
    orderNumber: 0,
    phone: "",
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    endDate: "",
    total: 0,
    parts: 0,
  });

  const mapFilterData = (data) => {
    filterModel.branchId = branchId;
    filterModel.unitId = data.unitId;
    filterModel.size = data.size;
    filterModel.part = data.part;
    filterModel.status = data.status;
    filterModel.fullName = data.fullName;
    filterModel.orderNumber = data.orderNumber;
    filterModel.phone = data.phone;
    filterModel.startDate = data.startDate;
    filterModel.endDate = data.endDate;
    filterModel.total = data.total;
    filterModel.parts = data.parts;
    setFilterModel({ ...filterModel });
  };

  const filterModelRef = useRef(filterModel);

  const [snappOrder, setSnappOrder] = useState({
    orderInfo: {
      id: 0,
      deliveryTypeName: "",
      paymentTypeName: "",
      statusCode: 0,
      invoiceId: 0,
      estimation: 0,
    },
    orderData: {
      code: "",
      price: 0,
      expeditionType: "",
      orderDate: 0,
      userCode: "",
      userAddressCode: "",
      statusCode: 54,
      fullName: "",
      firstName: "",
      lastName: "",
      latitude: 0,
      longitude: 0,
      deliverAddress: "",
      comment: null,
      phone: "",
      tax: 0,
      unitTitle: "",
      deliveryPrice: 0,
      packingPrice: 0,
      deliveryTime: 0,
      preparationTime: 0,
      taxCoeff: 0,
      vat: 0,
      discountType: null,
      discountValue: 0,
      newOrderDate: "",
      orderCoupon: null,
      orderPaymentTypeCode: "",
      preOrderTime: 0,
      vendorMaxPreparationTime: 0,
      vendorCode: "poooej",
      couponDiscountVendorShareAmount: 0,
      couponDiscountSfShareAmount: 0,
      products: [],
    },
  });

  const [snappSecurity, setSnappSecurity] = useState({
    vendorCode: "",
    snappToken: "",
  });

  const [snappVerifyModel, setSnappVerifyModel] = useState({
    watchId: 0,
    orderCode: "",
    snappToken: "",
  });

  const [acceptOrderModel, setAcceptOrderModel] = useState({
    watchId: 0,
    packingPrice: 0,
    delta: 0,
    deliveryTime: 0,
    riderPickupTime: 0,
    estimation: 0,
    orderCode: "",
    cashDeskId: deskId,
    shipmentId: 0,
    snappToken: "",
    acceptDescription: true,
  });

  const [rejectReasons, setRejectReasons] = useState([]);

  const [rejectModel, setRejectModel] = useState({
    watchId: 0,
    reasonId: 0,
    comment: "",
    nonExistents: [],
    orderCode: "",
    snappToken: "",
  });

  const [newIemStatuses, setNewItemStatuses] = useState([56, 713, 714]);

  const snappAudio = SoundEffect.snappAudio();

  const palySoundEffect = () => {
    try {
      snappAudio.play();
    } catch (error) {
      console.log(error);
    }
  };

  const getSettings = async () => {
    const resp = await apiMethod.getSettingByName(branchId, "LocalServices");
    if (!methods.showApiErrors(resp)) return false;

    let settings = JSON.parse(resp.data.settingItems);
    let setting = await settings.find((x) => x.KeyName === "HostPath");
    localService.baseUrl = setting.SettingValue;
    setLocalService({ ...localService });
  };

  const getLocalPrinters = async () => {
    try {
      const localPrintersResp = await apiMethod.getLocalPrinters(
        localService.baseUrl
      );
      if (!methods.showApiErrors(localPrintersResp)) {
        throw new Error("Error fetching local printers");
      }
      setlocalPrinters(localPrintersResp.data);
    } catch (error) {
      methods.showErrors(["خطا در اتصال پرینتر "]);
      console.log(error);
    }
  };

  const bindSnappToken = async (unitId) => {
    const response = await apiMethod.getSnappToken(branchId, unitId);
    if (!methods.showApiErrors(response)) return false;
    snappSecurity.snappToken = response.data.token;
    snappSecurity.vendorCode = response.data.clientId;
    setSnappSecurity({ ...snappSecurity });
    snappVerifyModel.snappToken = snappSecurity.snappToken;
    setSnappVerifyModel({ ...snappVerifyModel });
    acceptOrderModel.snappToken = snappSecurity.snappToken;
    setAcceptOrderModel({ ...acceptOrderModel });
    rejectModel.snappToken = snappSecurity.snappToken;
    setRejectModel({ ...rejectModel });
  };

  const bindBaseInfo = async () => {
    if (staticsInfo.cashDeskId > 0) {
      setStaticRoutes(staticsInfo.cashDeskId);
      acceptOrderModel.cashDeskId = staticsInfo.cashDeskId;
      setAcceptOrderModel({ ...acceptOrderModel });
    }
    const resp = await apiMethod.getSnappStatuses();
    if (methods.showApiErrors(resp)) setStatuses(resp.data);

    const resp2 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp2)) setUnits(resp2.data);

    await bindCashdesks();

    getLocalPrinters();
  };

  const bindCashdesks = async () => {
    const resp = await apiMethod.getUserCashdesks(branchId, 0);
    if (methods.showApiErrors(resp)) setCashDesks(resp.data);
    const allInactive = resp.data.every((item) => item.isActive === false);
    if (allInactive) {
      setInActiveModal(true);
    }
  };

  const bindRejectReseasons = async () => {
    const resp2 = await apiMethod.getSnappRejectReasons({
      snappToken: snappSecurity.snappToken,
    });
    if (methods.showApiErrors(resp2)) setRejectReasons(resp2.data);
  };

  const getGridData = async (showLoading) => {
    if (showLoading) setLoading(true);

    const resp = await apiMethod.getSnappOrders(filterModel);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    if (showLoading) setLoading(false);
  };

  const bindGridData = async (showLoading) => {
    if (showLoading) setLoading(true);

    const resp = await apiMethod.getSnappOrders(filterModelRef.current);
    if (methods.showApiErrors(resp)) {
      filterModelRef.current.total = resp.total;
      filterModelRef.current.parts = methods.calcPageParts(
        resp.total,
        filterModelRef.current.size
      );
      mapFilterData(filterModelRef.current);
      setGridData(resp.data);
    }
    if (showLoading) setLoading(false);
  };

  const setHookInerval = () => {
    const intervalId = setInterval(() => {
      bindGridData(false);
    }, 15000);
    return intervalId;
  };

  const searchData = async () => {
    await getGridData(true);
  };

  useEffect(() => {
    filterModelRef.current = filterModel;
  }, [filterModel]);

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getSettings();
      await bindBaseInfo();
      await getGridData(false);
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  useEffect(() => {
    const bindData = async () => {
      createConnection();
    };
    bindData();
  }, []);

  useEffect(() => {
    const intervalId = setHookInerval();
    return () => clearInterval(intervalId);
  }, []);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = "";
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.status = 0;
    filterModel.fullName = "";
    filterModel.phone = "";
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.endDate = "";
    filterModel.total = 0;
    filterModel.parts = 0;
    filterModel.orderNumber = 0;
    setFilterModel({ ...filterModel });
    getGridData(true);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData(false);
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const showDetailModal = async (status) => {
    setShowOrderDetail(status);
  };

  const getReadyOrder = async () => {
    const resp1 = await apiMethod.pickSnappOrderDierctly(snappVerifyModel);
    if (!methods.showApiErrors(resp1)) return false;

    const resp3 = await apiMethod.getWatchItemInfo(snappVerifyModel.watchId);
    if (methods.showApiErrors(resp3)) {
      mapSnappOrder(resp3.data);
    }
    return true;
  };

  const mapSnappOrder = (data) => {
    snappOrder.orderData = JSON.parse(data.snappData);
    snappOrder.orderInfo.id = data.id;
    snappOrder.orderInfo.statusCode = data.statusCode;
    snappOrder.orderInfo.deliveryTypeName = data.deliveryTypeName;
    snappOrder.orderInfo.paymentTypeName = data.paymentTypeName;
    snappOrder.orderInfo.deliveryType = data.deliveryType;
    snappOrder.orderInfo.invoiceId = data.invoiceId;
    snappOrder.orderInfo.estimation = data.estimation;
    snappOrder.orderData.unitTitle = data.unitTitle;
    setSnappOrder({ ...snappOrder });
    // acceptOrderModel.estimation = data.estimation;
    // setAcceptOrderModel({ ...acceptOrderModel });
  };

  const isNewOrder = (code) => {
    if (newIemStatuses.includes(code)) return true;

    return false;
  };

  const getColorClass = (code) => {
    code = parseInt(code);
    if (isNewOrder(code)) return "snapp-bg-yellow";
    if (code === 54 || code === 51) return "snapp-bg-red";
    if (code === 42) return "snapp-bg-green";
    return "";
  };

  const calcEtimateTime = (order) => {
    if (order.deliveryType === 1) {
      acceptOrderModel.deliveryTime = 70;
      acceptOrderModel.riderPickupTime = 0;
    } else if (order.deliveryType === 2) {
      acceptOrderModel.deliveryTime = 0;
      acceptOrderModel.riderPickupTime = 20;
    } else {
      acceptOrderModel.deliveryTime = 20;
      acceptOrderModel.riderPickupTime = 0;
    }
    acceptOrderModel.estimation =
      acceptOrderModel.deliveryTime + acceptOrderModel.riderPickupTime;
    setAcceptOrderModel({ ...acceptOrderModel });
  };

  const showSnappOrder = async (order) => {
    mapSnappOrder(order);
    calcEtimateTime(order);

    setLoading(true);
    await bindSnappToken(order.saleUnitId);
    if (rejectReasons.length === 0) await bindRejectReseasons();

    snappVerifyModel.watchId = order.id;
    snappVerifyModel.unitId = order.saleUnitId;
    snappVerifyModel.orderCode = order.code;
    setSnappVerifyModel({ ...snappVerifyModel });

    if (isNewOrder(order.statusCode)) await getReadyOrder();

    acceptOrderModel.watchId = order.id;
    acceptOrderModel.orderCode = order.code;
    acceptOrderModel.packingPrice = order.packingPrice;

    if (methods.isNullOrEmptyString(snappOrder.orderData.comment))
      acceptOrderModel.acceptDescription = true;
    else acceptOrderModel.acceptDescription = false;

    setAcceptOrderModel({ ...acceptOrderModel });

    rejectModel.watchId = order.id;
    rejectModel.orderCode = order.code;
    setRejectModel({ ...rejectModel });
    setLoading(false);
    showDetailModal(true);
    getGridData(false);
  };

  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(socketURL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveSnappOrder", (bid, orderData) => {
      bindGridData(false);
      palySoundEffect();
    });
  };

  const validAcceptModel = () => {
    let errors = [];
    if (
      acceptOrderModel.cashDeskId === 0 ||
      acceptOrderModel.cashDeskId === "0"
    )
      errors.push(".صندوق سفارش باید مقدار داشته باشد");

    if (acceptOrderModel.watchId === 0)
      errors.push(".شناسه سفارش اسنپ باید مقدار داشته باشد");

    if (
      acceptOrderModel.deliveryTime === 0 &&
      acceptOrderModel.riderPickupTime === 0
    )
      errors.push(".زمان تحویل سفارش باید مقدار داشته باشد");

    if (!acceptOrderModel.acceptDescription)
      errors.push("مشاهده توضیحات سفارش را تایید کنید.");

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const setAcceptTimes = () => {
    if (snappOrder.orderInfo.deliveryType === 1) {
      acceptOrderModel.deliveryTime = acceptOrderModel.estimation;
      acceptOrderModel.riderPickupTime = 0;
    } else if (snappOrder.orderInfo.deliveryType === 2) {
      acceptOrderModel.deliveryTime = 0;
      acceptOrderModel.riderPickupTime = acceptOrderModel.estimation;
    } else {
      acceptOrderModel.deliveryTime = acceptOrderModel.estimation;
      acceptOrderModel.riderPickupTime = 0;
    }
    setAcceptOrderModel({ ...acceptOrderModel });
  };

  const manualyAccept = async () => {
    setLoading(true);
    const resp = await apiMethod.acceptAndImportSnappOrder(acceptOrderModel);
    setLoading(false);
    if (!methods.showApiErrors(resp)) return false;

    getGridData(false);
    setShowOrderDetail(false);
  };

  const acceptOrder = async (doPrint) => {
    setAcceptTimes();
    if (!validAcceptModel()) return false;
    setLoading(true);
    const accResp = await apiMethod.acceptSnappOrder(acceptOrderModel);
    if (!methods.showApiErrors(accResp)) return false;

    if (doPrint) printInvoice(snappOrder.orderInfo.id, 3);
    setShowOrderDetail(false);
    getGridData(false);
    setLoading(false);
  };

  const rejectOrder = async () => {
    setLoading(true);
    const resp = await apiMethod.rejectSnappOrder(rejectModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setShowOrderDetail(false);
    getGridData(false);
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    setLoading(false);
  };

  const getPrintModel = async (snappOrderId) => {
    const resp = await apiMethod.getSnappOrderPrintInfo(snappOrderId);
    if (methods.showApiErrors(resp)) {
      printModel.orderPrintModel = resp.data.orderPrintModel;
      printModel.kitchenPrintModel = resp.data.kitchenPrintModel;
      printModel.printers = resp.data.printers;
      setPrintModel({ ...printModel });
      await setPrinterDevices(printModel.printers);
      return true;
    } else {
      return false;
    }
  };

  const setPrinterDevices = async (printers) => {
    let orderPrinter = await printers.find((x) => x.printerUnitType === 1);
    let kitchenPrinter = await printers.find((x) => x.printerUnitType === 2);
    printModel.orderPrintModel.printerName = orderPrinter.name;
    printModel.kitchenPrintModel.printerName = kitchenPrinter.name;
    setPrintModel({ ...printModel });
  };

  const validPrinters = (printerUnitType) => {
    if (printModel.printers.length === 0) {
      methods.showErrors([
        "خطا در تنظیمات پرینتر. هیچ دستگاهی در نرم افزار تعریف نشده است.",
      ]);
      return false;
    }

    if (printerUnitType === 1) {
      if (methods.isNullOrEmptyString(printModel.orderPrintModel.printerName)) {
        methods.showErrors([
          "خطا در تنظیمات پرینتر. هیچ دستگاهی برای آشپزخانه تعریف نشده است.",
        ]);
        return false;
      } else if (
        !localPrinters.includes(printModel.orderPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در اتصالات دستگاه پرینتر " +
            printModel.orderPrintModel.printerName +
            " به کامپیوتر شما.",
        ]);
        return false;
      }
    }

    if (printerUnitType === 2) {
      if (
        methods.isNullOrEmptyString(printModel.kitchenPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در تنظیمات پرینتر. هیچ دستگاهی برای صندوق تعریف نشده است.",
        ]);
        return false;
      } else if (
        !localPrinters.includes(printModel.kitchenPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در اتصالات دستگاه پرینتر " +
            printModel.kitchenPrintModel.printerName +
            " به کامپیوتر شما.",
        ]);
        return false;
      }
    }

    return true;
  };

  const printOrderReceipt = async () => {
    if (!validPrinters(1)) return false;

    const apiRes = await apiMethod.orderBillPrint(
      localService.baseUrl,
      printModel.orderPrintModel
    );

    if (!methods.showApiErrors(apiRes)) return false;
  };

  const printKitchenOrder = async () => {
    if (!validPrinters(2)) return false;

    const apiRes = await apiMethod.kitchenOrderPrint(
      localService.baseUrl,
      printModel.kitchenPrintModel
    );

    if (!methods.showApiErrors(apiRes)) return false;
  };

  const printInvoice = async (snappOrderId, printType) => {
    var isOkInfo = await getPrintModel(snappOrderId);
    if (!isOkInfo) return false;

    if (printType === 1 || printType === 3) await printOrderReceipt();

    if (printType === 2 || printType === 3) await printKitchenOrder();
  };

  const setRangeEstime = (step) => {
    if (acceptOrderModel.estimation + step < 0) return false;
    acceptOrderModel.estimation += step;
    setAcceptOrderModel({ ...acceptOrderModel });
  };

  const setStaticRoutes = (cashdeskId) => {
    const path = `/sale/${branchId}/snappManager/Orders/${cashdeskId}`;
    window.history.pushState({ path: path }, "", path);
  };

  const doCancelOrder = async (orderId) => {
    if (orderId < 1) {
      methods.showErrors(["ابتدا باید یک سفارش برای ارسال ایجاد کنید."]);
      return false;
    }
    await apiMethod.cancelOrder(orderId);
  };

  const openFund = async (id) => {
    setLoading(true);
    const resp = await apiMethod.openCashDesk(id);
    if (methods.showApiErrors(resp)) {
      handleCloseFundModal();
    }
    setLoading(false);
    toast.success("صندوق مورد نظر شما باز شد.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    setLoading(false);
  };

  const handleCloseFundModal = () => {
    setInActiveModal(false);
  };

  const renderSnappOrders = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/#1`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/sale/${branchId}/#4`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                سفارش های اسنپ
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>سفارش های اسنپ</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-md-4 col-xxl-2">
                    <label htmlFor="funit" className="form-label">
                      نام مشتری
                    </label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.fullName}
                      onChange={(e) => {
                        filterModel.fullName = e.target.value;
                        filterModel.part = 1;
                        setFilterModel({ ...filterModel });
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") getGridData(true);
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-xxl-1">
                    <label htmlFor="orderNumber" className="form-label">
                      شماره
                    </label>
                    <input
                      id="orderNumber"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.orderNumber}
                      onChange={(e) => {
                        filterModel.orderNumber = e.target.value;
                        filterModel.part = 1;
                        setFilterModel({ ...filterModel });
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") getGridData(true);
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-xxl-2">
                    <label htmlFor="ddlStatuses" className="form-label">
                      وضعیت
                    </label>
                    <select
                      id="ddlStatuses"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.status}
                      onChange={(e) => {
                        filterModel.status = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه وضعیت ها</option>
                      {statuses.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 col-xxl-2">
                    <label htmlFor="ddlStatuses" className="form-label">
                      بخش های فروش
                    </label>
                    <select
                      id="ddlStatuses"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.unitId}
                      onChange={(e) => {
                        filterModel.unitId = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه بخش ها</option>
                      {units.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 col-xxl-2">
                    <label htmlFor="enddate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-xxl-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-xxl-1">
                    <div className="mt-4 pt-2">
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchData();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        شماره
                      </th>
                      <th scope="col vertical-center">بخش فروش</th>
                      <th scope="col vertical-center">مشتری</th>
                      <th scope="col vertical-center">شماره تماس</th>
                      <th scope="col vertical-center">نحوه ارسال</th>
                      <th scope="col vertical-center">مبلغ پرداختی</th>
                      <th scope="col vertical-center">تاریخ ثبت</th>
                      <th scope="col vertical-center">وضعیت</th>
                      <th scope="col vertical-center" width="120px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr
                        key={index}
                        className={getColorClass(item.statusCode)}
                      >
                        {/* <td scope="row">{index + 1}</td> */}
                        <td>{item.orderNumber}</td>
                        <td>{item.unitTitle}</td>
                        <td>{item.clientName}</td>
                        <td>{methods.formatPhoneNumber(item.clientPhone)}</td>
                        <td>{item.deliveryTypeName}</td>
                        <td>{methods.addNumSeperator(item.price)}</td>
                        <td>
                          {methods.toPersianDate(
                            item.orderDate,
                            "jYYYY/jMM/jDD ساعت HH:mm"
                          )}
                        </td>
                        <td>{item.statusName}</td>
                        <td>
                          {item.invoiceId > 0 && (
                            <>
                              <div className="dropdown btn-dropdown me-1">
                                <button
                                  className="btn btn-sm btn-purple dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  چاپ
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        printInvoice(item.id, 3);
                                      }}
                                      className="dropdown-item"
                                      href="#"
                                    >
                                      چاپ همه
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        printInvoice(item.id, 1);
                                      }}
                                      className="dropdown-item"
                                      href="#"
                                    >
                                      چاپ صندوق
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        printInvoice(item.id, 2);
                                      }}
                                      className="dropdown-item"
                                      href="#"
                                    >
                                      چاپ آشپزخانه
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </>
                          )}
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => {
                              showSnappOrder(item);
                            }}
                          >
                            جزئیات
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const ModalDetail = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showOrderDetail ? "block" : "none" }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">جزئیات سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  showDetailModal(false);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td>نام مشتری: {snappOrder.orderData.fullName}</td>
                    <td>
                      شماره تماس:{" "}
                      {methods.formatPhoneNumber(snappOrder.orderData.phone)}
                    </td>
                    <td>نحوه پرداخت: {snappOrder.orderInfo.paymentTypeName}</td>
                    <td>
                      تاریخ:{" "}
                      {methods.toPersianDate(
                        snappOrder.orderData.newOrderDate,
                        "jYYYY/jMM/jDD"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <b>نحوه ارسال: {snappOrder.orderInfo.deliveryTypeName}</b>
                    </td>
                    <td colSpan={2}>
                      <b>بخش فروش :{snappOrder.orderData.unitTitle}</b>
                    </td>
                    <td colSpan={2}>
                      <b>کد سفارش: {snappOrder.orderData.code}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      آدرس: {snappOrder.orderData.deliverAddress}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td className="text-center" colSpan={5}>
                      <h5 className="m-0">کالاها</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>عنوان</td>
                    <td>شناسه منو</td>
                    <td>تعداد</td>
                    <td>قیمت (تومان)</td>
                    <td>تخفیف اسنپ (تومان)</td>
                    <td>تخفیف فروشگاه (تومان)</td>
                  </tr>
                  {snappOrder.orderData.products.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{item.title}</td>
                        <td>{item.id}</td>
                        <td>{item.quantity}</td>
                        <td>{methods.addNumSeperator(item.originprice)}</td>
                        <td>
                          {methods.addNumSeperator(item.productDiscountSFShare)}
                        </td>
                        <td>
                          {methods.addNumSeperator(
                            item.productDiscountVendorShare
                          )}
                        </td>
                      </tr>
                      {item.toppings != null && (
                        <>
                          {item.toppings.map((topp, tindx) => (
                            <>
                              <tr key={tindx}>
                                <td>{topp.title}</td>
                                <td>{topp.id}</td>
                                <td>{topp.quantity}</td>
                                <td>
                                  {methods.addNumSeperator(
                                    topp.price + topp.discount
                                  )}
                                </td>
                                <td>{topp.discount}</td>
                                <td>0</td>
                              </tr>
                            </>
                          ))}
                        </>
                      )}
                    </>
                  ))}
                  {snappOrder.orderData.orderCoupon != null &&
                    snappOrder.orderData.orderCoupon.rewardParams != null && (
                      <>
                        <tr>
                          <td colSpan={5}>
                            <b>کوپن:</b>{" "}
                            {snappOrder.orderData.orderCoupon.title}
                          </td>
                        </tr>
                      </>
                    )}
                  <tr>
                    <td colSpan={2}>
                      تخفیف کوپن اسنپ:{" "}
                      {methods.addNumSeperator(
                        snappOrder.orderData.couponDiscountSfShareAmount
                      )}{" "}
                      تومان
                    </td>
                    <td colSpan={3}>
                      تخفیف کوپن فروشگاه:{" "}
                      {methods.addNumSeperator(
                        snappOrder.orderData.couponDiscountVendorShareAmount
                      )}{" "}
                      تومان
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      <b>توضیحات: {snappOrder.orderData.comment}</b>
                    </td>
                    <td colSpan={1}>
                      {!methods.isNullOrEmptyString(
                        snappOrder.orderData.comment
                      ) && (
                        <>
                          <div className="form-check f-xl">
                            <input
                              checked={acceptOrderModel.acceptDescription}
                              onChange={(e) => {
                                acceptOrderModel.acceptDescription =
                                  e.target.checked;
                                setAcceptOrderModel({ ...acceptOrderModel });
                              }}
                              className="form-check-input f-dark me-2 ms-0"
                              type="checkbox"
                              value=""
                              id="defaultCheck1"
                            />
                            <label
                              className="form-check-label"
                              for="defaultCheck1"
                            >
                              تایید توضیحات
                            </label>
                          </div>
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      هزینه بسته بندی:{" "}
                      {methods.addNumSeperator(
                        snappOrder.orderData.packingPrice
                      )}
                    </td>
                    <td colSpan={2}>
                      هزینه ارسال:{" "}
                      {methods.addNumSeperator(
                        snappOrder.orderData.deliveryPrice
                      )}
                    </td>
                    <td colSpan={2}>
                      مبلغ مالیات :
                      {methods.addNumSeperator(snappOrder.orderData.tax)}
                    </td>
                    <td className="bg-secondary text-light" colSpan={2}>
                      <h6 className="m-0">
                        مبلغ کل:{" "}
                        {methods.addNumSeperator(snappOrder.orderData.price)}{" "}
                        تومان
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={1}>
                      زمان تخمینی آماده سازی اسنپ:{" "}
                      {snappOrder.orderData.preparationTime} دقیقه
                    </td>
                    <td colSpan={2}>
                      زمان تخمینی ارسال اسنپ:{" "}
                      {snappOrder.orderData.deliveryTime} دقیقه
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="accordion mb-2" id="needtocall">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingNeedtocall">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseNeedtocall"
                      aria-expanded="true"
                      aria-controls="collapseNeedtocall"
                    >
                      <h5 className="m-0">نیازمند به تماس با اسنپ</h5>
                    </button>
                  </h2>
                  <div
                    id="collapseNeedtocall"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingNeedtocall"
                    data-bs-parent="#needtocall"
                  >
                    <div className="accordion-body">
                      <div className="row mb-4">
                        <div className="col-4">
                          <div className="form-group mb-3">
                            <label
                              htmlFor="ddlreasons"
                              className="form-label required-label"
                            >
                              دلیل نیازمندی
                            </label>
                            <select
                              id="ddlreasons"
                              className="form-select"
                              aria-label="Default select example"
                              value={rejectModel.reasonId}
                              onChange={(e) => {
                                rejectModel.reasonId = e.target.value;
                                setRejectModel({ ...rejectModel });
                              }}
                            >
                              {rejectReasons.map((item, index) => (
                                <option key={index} value={item.id}>
                                  {item.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="txtcomment" className="form-label">
                              توضیحات
                            </label>
                            <textarea
                              type="text"
                              className="form-control"
                              id="txtcomment"
                              rows={3}
                              value={rejectModel.comment}
                              onChange={(e) => {
                                rejectModel.comment = e.target.value;
                                setRejectModel({ ...rejectModel });
                              }}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn custome-btn btn-purple me-2"
                          onClick={() => {
                            rejectOrder();
                          }}
                        >
                          ثبت نیازمند تماس
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {(snappOrder.orderData.statusCode === 714 ||
                snappOrder.orderData.statusCode === 713) && (
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <label htmlFor="ddlStatuses" className="form-label">
                          صندوق
                        </label>
                        <select
                          id="ddlStatuses"
                          className="form-select"
                          aria-label="menu"
                          value={acceptOrderModel.cashDeskId}
                          onChange={(e) => {
                            const selectedDeskId = e.target.value;
                            acceptOrderModel.cashDeskId = selectedDeskId;
                            setAcceptOrderModel({ ...acceptOrderModel });
                            setStaticRoutes(selectedDeskId);
                            methods.setOrderingStatics(
                              staticsInfo.saleUnitId,
                              selectedDeskId
                            );
                          }}
                        >
                          <option value={0}>صندوق</option>
                          {cashDesks.map((item, index) => (
                            <option value={item.id} key={index}>
                              {item.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-4">
                        <label htmlFor="ddlStatuses" className="form-label">
                          زمان تحویل
                        </label>
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <button
                                onClick={() => {
                                  setRangeEstime(5);
                                }}
                                type="button"
                                className="btn btn-outline-purple"
                              >
                                <i className="bi bi-plus-lg"></i>
                              </button>
                            </div>
                          </div>
                          <input
                            id="estimation"
                            value={acceptOrderModel.estimation}
                            onChange={(e) => {
                              acceptOrderModel.estimation = e.target.value;
                              setAcceptOrderModel({ ...acceptOrderModel });
                            }}
                            type="text"
                            className="form-control"
                          />
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <button
                                onClick={() => {
                                  setRangeEstime(-5);
                                }}
                                type="button"
                                className="btn btn-outline-purple"
                              >
                                <i className="bi bi-dash-lg"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {snappOrder.orderData.statusCode != 714 &&
                snappOrder.orderData.statusCode != 713 && (
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-6">
                          زمان آماده سازی ثبت شده توسط فروشگاه :{" "}
                          {snappOrder.orderInfo.estimation} دقیقه
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={() => {
                  showDetailModal(false);
                }}
              >
                انصراف
              </button>
              {(snappOrder.orderData.statusCode === 61 ||
                (snappOrder.orderData.statusCode === 42 &&
                  snappOrder.orderInfo.invoiceId < 1)) && (
                <>
                  <button
                    type="submit"
                    className="btn custome-btn btn-purple w-50"
                    onClick={() => {
                      manualyAccept();
                    }}
                  >
                    ثبت دستی
                  </button>
                </>
              )}
              {snappOrder.orderData.statusCode === 56 && (
                <>
                  <button
                    type="submit"
                    className="btn custome-btn btn-purple w-50"
                    onClick={() => {
                      getReadyOrder();
                    }}
                  >
                    تایید دریافت سفارش
                  </button>
                </>
              )}
              {(snappOrder.orderData.statusCode === 714 ||
                snappOrder.orderData.statusCode === 713) && (
                <>
                  <button
                    type="submit"
                    className="btn custome-btn btn-purple w-25"
                    onClick={() => {
                      acceptOrder(true);
                    }}
                  >
                    تایید و چاپ
                  </button>
                  <button
                    type="submit"
                    className="btn custome-btn btn-purple w-25"
                    onClick={() => {
                      acceptOrder(false);
                    }}
                  >
                    تایید
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderSnappOrders()}
      {showOrderDetail && ModalDetail()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={showDetailModal(false)}
          text={"سفارش اسنپ"}
        />
      )}
      <Modal
        show={inActiveModal}
        backdropClassName="inactive-backdrop"
        onHide={handleCloseFundModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="d-flex align-items-center justify-content-between">
          <Modal.Title>باز کردن صندوق</Modal.Title>
          {funds.length === 0 && (
            <Link to={`/sale/${branchId}`}>
              <button className="btn btn-purple">بازگشت</button>
            </Link>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center justify-content-center gap-4">
            <span>شما حداقل باید یک صندوق باز داشته باشید.</span>
            {funds?.map((item) => (
              <div
                key={item.id}
                className="w-100 d-flex align-items-center justify-content-between"
              >
                <span>{item.title}</span>
                <button
                  className="btn btn-purple"
                  onClick={() => openFund(item.id)}
                >
                  باز کردن صندوق
                </button>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default SnappOrders;
